import { createTheme } from "@mui/material/styles";

/**
 * Global MUI theme shared across the consumer experience.
 * Extend this configuration when adding new palette or typography overrides.
 */
const theme = createTheme({
  palette: {
    primary: {
      main: "#348323",
    },
  },
});

export default theme;
